import React from 'react';
import { ArrowRightOutlined, LeftCircleOutlined } from '@ant-design/icons';
import COButton from 'shared/components/COButton';
import { ButtonLabels, RawMaterialProps } from 'enums/RawMaterialEnums';
import { ReactComponent as AddIcon } from 'assets/icons/add_enclosed.svg';
import clsx from 'clsx';
import { Address } from 'models/Address/address.model';
import styles from '../CreateProductFlow.module.scss';
import { ingredient, rawMaterialPayload } from 'views/CreateProductFlow/CreateProductFlowInterfaces';
import { FormikProps } from 'formik';

interface IngredientHeaderProps {
  isDisabled: boolean;
  buttonLoading: boolean;
  draftButtonLoading: boolean;
  handleGoBack: () => void;
  handleTopBackButton: () => void;
  handleOpenCancelModal: () => void;
  handleSaveAsDraft: () => void;
  arrayHelpers: {
    push: (value: ingredient) => void;
  };
  formikProps: FormikProps<rawMaterialPayload>;
}

const IngredientHeader: React.FC<IngredientHeaderProps> = ({
  isDisabled,
  buttonLoading,
  draftButtonLoading,
  handleGoBack,
  handleTopBackButton,
  handleOpenCancelModal,
  handleSaveAsDraft,
  arrayHelpers,
  formikProps,
}) => {
  return (
    <>
      <div className={styles.formHeaderContainer}>
        <div className={styles.formHeader}>
          <p className={styles.backButton} onClick={handleGoBack}>
            <LeftCircleOutlined />
          </p>
          <h2>{RawMaterialProps.RAW_MATERIAL_HEADING}</h2>
        </div>
        <div className={styles.formButtonContainer}>
          {isDisabled === false ? (
            <>
              <COButton
                text
                disabled={isDisabled}
                onClick={() =>
                  arrayHelpers.push({
                    ingredientName: undefined,
                    ingredientOrigin: '',
                    bestFitProductionRegion: undefined,
                    ingredientQuantity: '',
                    ingredientUnit: undefined,
                    origins: [],
                    address: new Address(),
                  })
                }>
                <AddIcon />
                {ButtonLabels.ADD_INGREDIENT}
              </COButton>
              <COButton
                text
                disabled={isDisabled}
                onClick={() => {
                  formikProps.setFieldValue(RawMaterialProps.PACKAGE_MATERIAL, [
                    ...formikProps.values.packageMaterials,
                    {
                      id: undefined,
                      packingMaterialName: undefined,
                      packingMaterialOrigin: undefined,
                      packingMaterialbestFitProductionRegion: undefined,
                      packingMaterialQuantity: '',
                      packingMaterialUnit: undefined,
                      numberOfUnitsPerPackingMaterial: '',
                      origins: [],
                      address: new Address(),
                    },
                  ]);
                }}>
                <AddIcon />
                {ButtonLabels.ADD_PACKAGING_MATERIAL}
              </COButton>
            </>
          ) : null}
          <COButton submit loading={buttonLoading}>
            {ButtonLabels.NEXT}
            <ArrowRightOutlined />
          </COButton>
        </div>
      </div>
      <div className={styles.easeDiv}>
        {isDisabled === true ? (
          <div
            className={clsx({
              [styles.topRightContainer]: true,
              [styles.backDisabledState]: isDisabled,
            })}>
            <COButton text onClick={handleTopBackButton}>
              Back
            </COButton>
          </div>
        ) : (
          isDisabled === false && (
            <div className={styles.topRightContainer}>
              <COButton text onClick={handleOpenCancelModal}>
                {ButtonLabels.CANCEL}
              </COButton>
              <COButton
                secondary
                disabled={isDisabled}
                loading={draftButtonLoading}
                onClick={handleSaveAsDraft}>
                {ButtonLabels.SAVE_AS_DRAFT}
              </COButton>
            </div>
          )
        )}
      </div>
    </>
  );
};

export default IngredientHeader;
